<template>
    <div>
        <card-header title="Registration Discounts" icon="fa-badge-dollar"></card-header>

        <card-toolbar>
            <button @click="$openCard('rmc-new-discount', {confId: props.confId}, card)"><i class="far fa-plus"></i>New Registration Discount</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <rmc-discount-tile
                    :card="card"
                    :discount="discount"
                    v-for="discount in conference.discounts"
                    @click="$openCard('rmc-edit-discount', {confId: discount.conference_id, discountId: discount.id}, card)"
                    :active="(child && child.definition.component === 'rmc-edit-discount' && discount.id === parseInt(child.props.discountId))"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import RmcDiscountTile from "../../../components/rmc/RmcDiscountTile";

    import {client as http} from '@/http_client';

    export default {
        components: {RmcDiscountTile, CardToolbar, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: []
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('rmc/conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>

<style>

</style>
